import { render, staticRenderFns } from "./HomeDashboard.vue?vue&type=template&id=665db218&scoped=true"
import script from "./HomeDashboard.vue?vue&type=script&lang=js"
export * from "./HomeDashboard.vue?vue&type=script&lang=js"
import style0 from "./HomeDashboard.vue?vue&type=style&index=0&id=665db218&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665db218",
  null
  
)

export default component.exports